module.exports = {
	"next": "siguiente",
	"skip": "Saltar a la creación de Cozy",
	"cancel": "anular",
	"back": "volver",
	"sign up": "inscribirse",
	"add email": "añadir una cuenta email",
	"welcome": "¡Vamos pues!",
	"confirm": "confirmar",
	"step preset": "ajustes",
	"step import": "importar sus datos",
	"step email settings": "configurar su email",
	"preset email": "e-mail",
	"preset email tip": "Esta dirección email puede ser útil para contactarlo(a) si pierde su contraseña.",
	"preset name": "nombre",
	"preset name tip": "Este nombre aparece cuando se comparten archivos con otras personas o cuando se les invita a eventos.",
	"preset password": "contraseña",
	"preset password tip": "Se requiere una contraseña segura de al menos 8 caracteres (se recomienda el uso de caracteres especiales).",
	"preset timezone": "zona horaria",
	"preset timezone tip": "Le permite visualizar correctamente las horas en su agenda.",
	"preset opt-in help": "Deseo ayudar a Cozy a mejorar la plataforma trasmitiéndole los datos estadísticos anonimos referidos a mi utilización.",
	"preset opt-out newsletter": "Quisiera que Cozy me informara de la evolución del producto (recomendado).",
	"import from google": "import my data from my Google account",
	"import google account": "Sincronizar su cuenta Gmail & importar agenda, contactos y fotos desde Google",
	"import google account tip": "Se requiere iniciar una sesión en su cuenta Google para autorizar a su Cozy a acceder a sus datos alojados en Google",
	"leave google title": "Importar sus datos a Cozy",
	"leave google help me": "¡No sé qué hacer, por favor ayúdenme!",
	"leave google sign in content": "Sign in to your Google account and authorize your Cozy to access it. You will get a complex string. Copy it in your clipboard.",
	"leave google sign in": "Iniciar sesión en Google",
	"leave google code content": "Pegar el código enviado por Google aquí debajo:",
	"leave google code": "código google",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "Escoger lo que usted quiere hacer con los datos almacenados en los servidores de Google:",
	"leave google choice sync gmail": "GMail - Acceder a su email desde Cozy",
	"leave google choice contacts": "Contactos Google - Copiar en mi Cozy",
	"leave google choice calendar": "Agenda Google - Copiar en mi Cozy",
	"leave google choice photos": "Fotos Google - Copiar en mi Cozy",
	"leave google confirm": "Importar datos",
	"import error": "Un error se produjo al tratar de importar sus datos. Trate de hacerlo más tarde con una aplicación adecuada.",
	"login welcome": "Bienvenido %{username}",
	"login enter your password": "Introducir su contraseña para acceder a su Cozy",
	"login password": "contraseña",
	"login otp": "Código de autenticación",
	"login submit": "iniciar sesión",
	"login auth success": "Autenticación exitosa, ¡ adelante !",
	"login recover": "¿Ha olvidado su contraseña? Envíenme las instrucciones por email para recuperarla",
	"login recover again": "¿No lo ha recibido? Enviénmelo de nuevo",
	"login recover sent title": "Email enviado",
	"login recover sent message": "Se le ha enviado un email con las instrucciones para restaurar su contraseña",
	"login recover error title": "Error al enviar el correo",
	"login recover error message": "Error al enviar el mensaje de recuperación de la contraseña, por favor chequear su MTA o ponerse en contacto con la administación del servidor",
	"login wrong password title": "Credenciales incorrectas",
	"login wrong password message": "Las credenciales que usted ha ingresado son incorrectas, por favor trate de nuevo",
	"reset welcome": "Restauración de la contraseña",
	"reset enter your password": "%{username}, por favor, introduzca su nueva contraseña para restaurarla",
	"reset password": "contraseña",
	"reset submit": "restaurar su contraseña",
	"reset auth success": "contraseña restaurada",
	"reset wrong password title": "Su contraseña no ha podido restaurarse",
	"reset wrong password message": "La contraseña que usted ha introducido es incorrecta, o su token de restauración ha expirado",
	"setup title": "Estamos configurando su Cozy...",
	"setup message": "Ya casi puede disponer de su nube personal en donde podrá almacenar sus datos.",
	"setup on mobile title": "¡Utilizar Cozy en su periférico Android!",
	"setup on mobile message": "Descargar la aplicación mobile Cozy en Google Play:",
	"welcome title": "¡Felicitaciones! Usted acaba de tomar el control de sus datos.",
	"welcome message": "Ahora usted puede almacenar sus datos en su cloud personal.  A diferencia de la mayoría de los servicios cloud, no hay ningún tipo de data-mining en su Cozy."
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/locales/es.json
 ** module id = 30
 ** module chunks = 1
 **/